import React from "react";
import { Droppable, DragDropContext } from "react-beautiful-dnd";

import styled from "@emotion/styled";
import { css } from "@emotion/react";

export default function HiringStageList(props) {
  const { onDragEndHiringStage } = props;

  const onDragEnd = (result) => {
    onDragEndHiringStage(result);
  };

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="hiring-stages-droppable-id">
        {(provided) => (
          <Styled.Container ref={provided.innerRef} {...provided.droppableProps}>
            {props.children}
            {provided.placeholder} {/* Increases space for dropping */}
          </Styled.Container>
        )}
      </Droppable>
    </DragDropContext>
  );
}

/* Styled Components
======================================================= */
let Styled: any;
Styled = {};

Styled.Container = styled.div((props) => {
  const t: any = props.theme;
  return css`
    label: HiringStageList;
    background-color: ${t.dark ? t.color.gray[800] : t.color.gray[100]};
  `;
});
